export const LOGIN = 'LOGIN';

export const ADD_CART = 'ADD_CART';
export const NEW_ORDER = 'NEW_ORDER';
export const CREATE_ORDER = 'CREATE_ORDER';
export const CHANGE_ORDER_ADDRESS = 'CHANGE_ORDER_ADDRESS';
export const CHANGE_ORDER_COUPON = 'CHANGE_ORDER_COUPON';
export const ORDER_CHANGE_COUNT = 'ORDER_CHANGE_COUNT';



// WEBPACK FOOTER //
// ./src/stores/mutation-types.js